import { HorizontalContainer, VerticalContainer, Wrapper } from '@american-autonomy/ag-ui';

import StatusPill from 'components/StatusPill';

import useTranslation from 'pages/MaintenancePage/hooks/useTranslation';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const WarningEntry: FunctionComponent<Props> = ({
    className = '',
    severity,
    testId = TEST_ID,
    text
}) => {
    const t = useTranslation();
    const labels = {
        caution: t.STATUS_CAUTION,
        critical: t.STATUS_CRITICAL,
        watching: t.WATCHING_LABEL
    };
    const variant = severity === 'critical' ? 'error' : 'warn';

    return (
        <VerticalContainer className={`${styles.warningEntry} ${className}`} testId={testId}>
            <HorizontalContainer className={styles.warningHead}>
                <StatusPill text={labels[severity]} variant={variant} />

                <Wrapper className={styles.warningText}>{text}</Wrapper>
            </HorizontalContainer>

            <HorizontalContainer className={styles.warningActions}>
                <Wrapper className={styles.warningAction}>{t.ACKNOWLEDGE}</Wrapper>

                <Wrapper className={styles.warningAction}>{t.ADD_NOTE}</Wrapper>
            </HorizontalContainer>
        </VerticalContainer>
    );
};

export default WarningEntry;
